module.exports = __webpack_public_path__ + "img/diamond_banner_hilo.fd14acfe.png";